export default {
    data() {
        return {
            openToolTips: [],
        }
    },

    methods: {
        addToolTips() {
            this.openToolTips = [];
            this.$refs.table.data = this.$refs.table.data.map((row) => {
                if(row.addresses) {
                    row.addresses = row.addresses.map((address) => {
                        address.show = false;
                        return address;
                    });
                }
                return row;
            })
        },

        tooltip(address) {
            if (this.showToolTip(address)) {
                return this.openToolTips.splice(this.openToolTips.indexOf(address.id), 1);
            }

            this.openToolTips.push(address.id);
        },

        showToolTip(address) {
            return this.openToolTips.includes(address.id);
        },
    }
}